import { SortDirection } from "../enums/sort-direction.enum";

export interface SortField {
  fieldName: string;
  direction: SortDirection;
}
